"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = TrustpilotReviews;

var _react = _interopRequireWildcard(require("react"));

var _reactHelmet = require("react-helmet");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _filterLocale = _interopRequireDefault(require("../utils/filter-locale"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function TrustpilotReviews({
  language,
  culture,
  theme,
  height,
  width,
  template,
  business,
  username
}) {
  const [loaded, setLoaded] = (0, _react.useState)(false);
  const ref = (0, _react.useRef)();
  const {
    domain,
    locale
  } = (0, _filterLocale.default)(language, culture);
  (0, _react.useEffect)(() => {
    if (typeof window !== "undefined" && window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
      setLoaded(true);
    }
  }, [loaded]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: "trustpilot-widget",
    "data-locale": locale,
    "data-template-id": template,
    "data-businessunit-id": business,
    "data-style-height": height,
    "data-style-width": width,
    "data-theme": theme
  }, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("script", {
    type: "text/javascript",
    src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
    async: true
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: `https://${domain}.trustpilot.com/review/${username}`,
    target: "_blank",
    rel: "noopener"
  }, "Trustpilot"));
}

TrustpilotReviews.propTypes = {
  language: _propTypes.default.string,
  culture: _propTypes.default.string,
  theme: _propTypes.default.string,
  height: _propTypes.default.string,
  width: _propTypes.default.string,
  template: _propTypes.default.string.isRequired,
  business: _propTypes.default.string.isRequired,
  username: _propTypes.default.string.isRequired
};
TrustpilotReviews.defaultProps = {
  language: "en",
  culture: "US",
  theme: "light",
  height: "52px",
  width: "100%"
};